import { useParams } from "react-router-dom";
import useBackend from "./use_backend";
import { getValidOverrides } from "../scripts/api_v2/overrides_client";
import { REACT_QUERY_KEYS } from "../enums/react_query_key_enum";
import { useQuery } from "@tanstack/react-query";

export function useOverrides() {
  const backend = useBackend();
  const params = useParams();

  return useQuery({
    queryKey: [REACT_QUERY_KEYS.CURRENT_OVERRIDES, backend.fetch, params.site_id],
    queryFn: () => getValidOverrides(backend.fetch, params.site_id),
    refetchInterval: 30000,
  });
}
